import { Box, Button, ButtonProps, BoxProps } from "@mui/material";
import { withStyles } from "@mui/styles";
import { colors, getFontFamilyBySupportedApplication } from "~/theme";

type WithDarkTheme = { darkTheme?: boolean };

const StyledButton = withStyles({
    root: {
        borderRadius: "28px",
        textTransform: "inherit",
        fontFamily: getFontFamilyBySupportedApplication(),
    },
    containedPrimary: {
        color: ({ darkTheme }: WithDarkTheme) =>
            darkTheme ? colors.black : colors.white,
        backgroundColor: ({ darkTheme }: WithDarkTheme) =>
            darkTheme ? colors.white : colors.black,
        "&:hover": {
            color: ({ darkTheme }: WithDarkTheme) =>
                darkTheme ? colors.black : colors.white,
            backgroundColor: ({ darkTheme }: WithDarkTheme) =>
                darkTheme ? colors.white : colors.black,
        },
    },
    contained: {
        "&[disabled]": {
            backgroundColor: ({ darkTheme }: WithDarkTheme) =>
                darkTheme ? colors.white40 : colors.black12,
        },
    },
})(Button);

export function RoundButton({
    width,
    height,
    ...props
}: ButtonProps & {
    width?: BoxProps["width"];
    height?: BoxProps["height"];
    darkTheme?: boolean;
}) {
    return (
        <Box width={width} height={height}>
            <StyledButton
                sx={{
                    width,
                    height,
                }}
                {...props}
            />
        </Box>
    );
}
